<script setup>
import { ref, computed, onMounted, watch } from 'vue'
import { blogService } from '@/http'
import { timeAgo } from '@/Utils/date'
import { useRoute } from 'vue-router'

import ThumbCover from '@/Components/ThumbCover.vue'
import Link from '../Components/Link.vue'

const items = ref([])

const page = ref(1)

const total = ref(0)

const route = useRoute()

// const filter = computed(() => {
//   console.log(222, route.query)
//   let query = {...route.query}
//   return {
//     page: page.value,
//     ...query
//   }
// })


const fetchData = () => {
  let filter = {
    page: page.value,
    ...route.query,
    ...route.params
  }
  blogService.index(filter).then(res => {
    total.value = res.data.total
    if(page.value > 1) {
      items.value = [...items.value, ...res.data.items]
      return
    }
    items.value = res.data.items
  })
}

const loadMore = () => {
  page.value++
  fetchData()
}


watch(
  () => route.query,
  async () => {
    fetchData()
  },
  {
    flush: 'post',
    immediate: true
  }
)
</script>


<style lang="scss">
.blogs {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(1, 1fr);
  margin-bottom: 20px;

  // @include mq('sm') {
  //   grid-template-columns: repeat(3, 1fr);
  //   gap: 10px;
  // }

  // @include mq('xl') {
  //   grid-template-columns: repeat(4, 1fr);
  //   gap: 10px;
  // }
}

.thumb {
  display: flex;
  flex-direction: column;
  gap: 5px;
  overflow: hidden;
  background: var(--background);
  
  @include mq('md') {
    padding: 10px;
    box-shadow: 0 0 #0000, 0 0 #0000, 0 0 1px rgba(28, 41, 61, .08);
    border-radius: 6px;
  }

  &__img {
    
  }

  &__title {
    color: var(--color-text);
    font-size: 18px;
    line-height: 1.4;
    font-weight: normal;
    font-weight: bold;
  }

  &__user {
    margin-bottom: 10px;
  }

  &__content {
    max-height: 100px;
    position: relative;
    overflow: hidden;
  }
  &__text {
    position: relative;
    &::after {
      position: absolute;
      top: 65px;
      left: 0;
      right: 0;
      display: block;
      content: "";
      height: 30px;
      background: linear-gradient(180deg, #fff0 30%, #fff);
    }
  }
  &__tags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
}


.thumb-user {
  display: grid;
  grid-template-columns: 40px 1fr 40px;
  gap: 0 10px;
  line-height: 1;

  &__photo {
    //grid-row: span 2;
    display: flex;
    align-items: center;
    font-size: 35px;
    justify-content: center;
    height: 40px;

    img {
      object-fit: cover;
      height: 100%;
      width: 100%;
      border-radius: 50%;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__name {
    font-weight: bold;
  }

  &__btn {
    font-size: 24px;
    display: flex;
  }
}

// .tag {
//   display: inline-flex;
//   align-items: center;
//   gap: 5px;
//   height: 30px;
//   padding: 0 8px;
//   border-radius: 6px;
//   background: var(--background-primary);
// }

</style>

<template>
  <div class="blogs">
    <router-link 
      v-for="item in items" 
      :key="item.id"
      class="thumb"
      :to="{
        name: 'blog',
        params: {
          id: item.id
        }
      }"
    >
      <Link 
        class="thumb__info thumb-user" 
        tag="div"
        :to="{ name: 'user', params: { user: item.user.id } }"
      >
        <div class="thumb-user__photo">
          <img v-if="item.user.photo" :src="item.user.photo" alt="" />
          <Icon v-else name="face-smile" />
        </div>
        <div class="thumb-user__info">
          <span class="thumb-user__name">{{ item.user.name }}</span>
          <span class="thumb-user__date">{{ timeAgo(item.created_at) }}</span>
        </div>
      </Link>
      <h3 class="thumb__title">{{ item.title }}</h3>
      <div class="thumb__content">
        <div class="thumb__text" v-html="item.html"></div>
      </div>
      <ThumbCover class="thumb__img" :item="item" />
      <div class="thumb__tags">
        <Link 
          v-for="tag in item.tags"
          :key="tag.id"
          :to="{
            name: 'tag',
            params: {
              tag: tag.slug
            }
          }"
          class="tag">
          <span>{{ tag.icon }}</span>
          <span>{{ tag.title }}</span>
        </Link>
      </div>
    </router-link>
  </div>
  <button 
    v-if="items.length < total"
    @click.prevent="loadMore"
    class="btn btn--center"
  >
    Показать еще
  </button>
</template>